export const QID_PATTERN =
  /^(\d+)-(\d+|X)-(\d+|X)-(\d+|X)-(\d+|X)-(\d+|X)-(\d+|X)-(\d+|\d+D|\d|X)-(\d+|X)-(\d+D|\d+)$/;

export function validateQId(qId: string): boolean {
  return QID_PATTERN.test(qId);
}
